
/**
 * Utility functions for decoding HTML entities in recipe data
 */

/**
 * Decodes HTML entities in a text string
 */
export const decodeHtmlEntities = (text: string): string => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
};
